export const formatEmail = (value) => {
  return value?.toLowerCase();
};
